import { reportShownError } from '~/utils/errorReporting'
import { getBackendErrorMessage, getBackendErrorMessages, getDisplayMessage, getDisplayMessages } from '~/utils/http/api-error'

// The user-facing message policies of `~/utils/http/api-error` with the localized
// generic failure already bound as their fallback, so a catch handler cannot leave
// a failure blank by forgetting it. Diagnostic-only callers (telemetry, logs) call
// the utils directly with their own text.
//
// Reading a message here means the failure is being shown. An unexpected error (a code
// bug, a third-party exception) reads as the generic text, which tells nobody what broke,
// so it is reported as it is read: a catch handler cannot forget that either.
export const useErrorText = () => {
  const i18n = useI18n()
  const { $appInsights } = useNuxtApp()
  const genericMessage = () => i18n.t('error.somethingWrong')
  const shown = <T>(read: (error: unknown, fallback: string) => T) => (error: unknown): T => {
    reportShownError(error, $appInsights)
    return read(error, genericMessage())
  }

  return {
    genericMessage,
    displayMessages: shown(getDisplayMessages),
    displayMessage: shown((error, fallback) => getDisplayMessage(error, fallback)),
    backendMessages: shown(getBackendErrorMessages),
    backendMessage: shown(getBackendErrorMessage)
  }
}
